var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stepper pb-5" }, [
    _c(
      "ul",
      { staticClass: "stepper__list", attrs: { role: "tablist" } },
      _vm._l(_vm.steps, function (step, key) {
        return _c(
          "li",
          {
            key: key,
            staticClass: "stepper__list__item",
            attrs: { role: "presentation" },
          },
          [
            _c(
              "p",
              {
                staticClass: "stepper__list__link mb-0",
                class: {
                  "stepper__list__link--completed":
                    step.stepNumber < _vm.actualStep,
                },
                attrs: {
                  "data-toggle": "tab",
                  "aria-controls": "stepper-step-1",
                  role: "tab",
                  title: key,
                },
              },
              [
                _c("span", { staticClass: "round-tab" }, [
                  _vm._v(_vm._s(step.stepNumber)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "completed" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "11",
                        viewBox: "0 0 16 11",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#303233",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.4",
                            d: "M1 5.154v0L5.9 10v0L15 1v0",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "h6",
              {
                staticClass:
                  "stepper__list__title font__family--gotham font__weight--light font__color__gray",
              },
              [_vm._v("\n                " + _vm._s(step.name))]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }